import React, { useReducer } from "react";

//likes controller from https://codesandbox.io/s/like-dislike-buttons-made-with-react-hooks-fo3o2?file=/src/index.js:1589-1602   i had one it wasnt working propely i tried
const HANDLE_LIKE = Symbol("HANDLE_LIKE");
const HANDLE_DISLIKE = Symbol("HANDLE_DISLIKE");
const initialState = {
  likes: 100,
  dislikes: 20,
  active: null,
};

const reducer = (state, action) => {
  const { likes, dislikes, active } = state;

  switch (action.type) {
    case HANDLE_LIKE:
      return {
        ...state,
        likes: state.likes + 1,
        dislikes: active === "dislike" ? dislikes - 1 : dislikes,
        active: "like",
      };
    case HANDLE_DISLIKE:
      return {
        ...state,
        likes: active === "like" ? likes - 1 : likes,
        active: "dislike",
        dislikes: dislikes + 1,
      };
    default:
      return state;
  }
};

export const LikeOrDislike = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { likes, dislikes, active } = state;
  return (
    <div style={{ display: "flex" }}>
      <button
        style={{
          color: active === "like" ? "green" : "black",
          marginRight: "10px",
        }}
        onClick={() => (active !== "like" ? dispatch({ type: HANDLE_LIKE }) : null)}
      >
        <strong>Likes</strong>
        &nbsp;|&nbsp;
        {likes}
      </button>
      <button
        style={{ color: active === "dislike" ? "red" : "black" }}
        onClick={() => (active !== "dislike" ? dispatch({ type: HANDLE_DISLIKE }) : null)}
      >
        <strong>Dislikes</strong>
        &nbsp;|&nbsp;
        {dislikes}
      </button>
    </div>
  );
};
